import { render, staticRenderFns } from "./dashboard-history-order.vue?vue&type=template&id=10bc0f38&scoped=true"
import script from "./dashboard-history-order.vue?vue&type=script&lang=js"
export * from "./dashboard-history-order.vue?vue&type=script&lang=js"
import style0 from "./dashboard-history-order.vue?vue&type=style&index=0&id=10bc0f38&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10bc0f38",
  null
  
)

export default component.exports